import React from 'react';
import { AppBar, Toolbar, Typography, Button, Chip, Box, Stack } from '@mui/material';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { useAgencyLogoutMutation } from '../slices/agencyAuthApiSlice';
import { agencyLogout } from '../slices/authSlice';

const navLinkStyle = ({ isActive }) => ({
  color: '#fff',
  textDecoration: 'none',
  opacity: isActive ? 1 : 0.75,
  fontWeight: isActive ? 700 : 400,
  marginRight: 20,
});

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { agencyInfo } = useSelector((state) => state.agencyAuth);
  const [logoutApiCall] = useAgencyLogoutMutation();

  const handleLogout = async () => {
    try {
      await logoutApiCall().unwrap();
    } catch (err) {
      // Even if the network call fails, still clear local state below —
      // there's no reason to trap the user on a portal they can't reach.
      console.error('Agency logout request failed:', err);
    } finally {
      dispatch(agencyLogout());
      navigate('/login');
    }
  };

  if (!agencyInfo) return null;

  return (
    <AppBar position="static" color="primary" enableColorOnDark>
      <Toolbar sx={{ flexWrap: 'wrap', gap: 1 }}>
        <Typography variant="h6" sx={{ mr: 4, whiteSpace: 'nowrap' }}>
          Beaumont Agency Portal
        </Typography>

        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          <NavLink to="/shifts/available" style={navLinkStyle}>
            Available Shifts
          </NavLink>
          <NavLink to="/shifts/mine" style={navLinkStyle}>
            My Shifts
          </NavLink>
        </Box>

        <Stack direction="row" spacing={1.5} alignItems="center">
          <Typography variant="body2">{agencyInfo.name}</Typography>
          {agencyInfo.agencyTier && (
            <Chip
              size="small"
              label={agencyInfo.agencyTier}
              sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff' }}
            />
          )}
          <Button color="inherit" variant="outlined" size="small" onClick={handleLogout}>
            Logout
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
